import React from "react";

const CalculatorBonifications = ({ data }) => {
    
    return(
        <div className="mx-auto items-center text-center pt-10 pb-10 xs:p-8">
            <img src={data.image} className="mx-auto pb-8 xs:h-32" alt="logo"/>
            <h1 classname="text-6xl xs:text-3xl">{data.title}</h1>
            <h3 classname="text-4xl xs:text-2xl">{data.text}</h3>
            <h3 classname="text-4xl text-[#EC0000]">{data.textTwo}</h3>
        </div>

    );
};

export default CalculatorBonifications; 